// @ts-check
/* eslint-env browser */

export class StatusTag extends HTMLElement {
  static get observedAttributes () {
    return ['data-complete', 'data-has-geometry', 'data-feature-type']
  }

  connectedCallback () {
    this.#render()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.#render()
    }
  }

  #render () {
    const featureType = this.getAttribute('data-feature-type')
    const hasGeometry = this.getAttribute('data-has-geometry') === 'true'
    const isTreeOrZone = featureType === 'tree' || featureType === 'tree_preservation_zone'

    // Only show orange tag for trees/zones without geometry
    if (isTreeOrZone && !hasGeometry) {
      const tagText = featureType === 'tree' ? 'Add point' : 'Add shape'
      this.innerHTML = `<strong class="govuk-tag govuk-tag--orange">${tagText}</strong>`
      return
    }

    const isComplete = this.getAttribute('data-complete') === 'true'
    const text = isComplete ? 'Complete' : 'For review'
    const colorClass = isComplete ? 'govuk-tag--green' : 'govuk-tag--blue'

    this.innerHTML = `<strong class="govuk-tag ${colorClass}">${text}</strong>`
  }
}

customElements.define('status-tag', StatusTag)
